import Handlebars from "handlebars";
import { useEffect, useState } from "react";
import { EmailTemplate } from "../models/notification";

export interface EmailPreviewProps {
  emailTemplate: EmailTemplate;
  emailTemplateVariables: any;
  useEditorStyle: boolean;
}

export const EmailPreview = ({
  emailTemplate,
  emailTemplateVariables = {},
  useEditorStyle,
}: EmailPreviewProps) => {
  const [compiledEmailTemplate, setCompiledEmailTemplate] =
    useState<EmailTemplate>();

  useEffect(() => {
    compileEmailTemplate(emailTemplate, emailTemplateVariables);
  }, [emailTemplate, emailTemplateVariables]);

  const compileEmailTemplate = async (
    template: EmailTemplate,
    params: Map<string, string>,
  ) => {
    const complied = Handlebars.compile(template.html)(params);
    setCompiledEmailTemplate({
      ...template,
      html: complied,
    });
  };

  if (!emailTemplate) return null;

  return (
    <div className={useEditorStyle ? "quill" : ""}>
      <div className="ql-container ql-snow !border-0 [&_p]:leading-normal">
        <div
          className={`${useEditorStyle ? "ql-editor" : ""} p-4 flex flex-col`}
          dangerouslySetInnerHTML={{
            __html: compiledEmailTemplate?.html || "",
          }}
        />
      </div>
    </div>
  );
};
